"use client";

import { c as _c } from "react/compiler-runtime";
import { DELEGATION_ABI } from "@/abis/abis";
import { useAuth } from "@/components/auth/Auth";
import { PRIMARY_ADDRESS_USE_CASE } from "@/components/delegation/delegation-constants";
import EtherscanIcon from "@/components/user/utils/icons/EtherscanIcon";
import OpenseaIcon from "@/components/user/utils/icons/OpenseaIcon";
import CopyIcon from "@/components/utils/icons/CopyIcon";
import { DELEGATION_ALL_ADDRESS, DELEGATION_CONTRACT, NEVER_DATE } from "@/constants/constants";
import type { ApiWallet } from "@/generated/models/ApiWallet";
import { getTransactionLink } from "@/helpers/Helpers";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { useEffect, useRef, useState } from "react";
import { Tooltip } from "react-tooltip";
import { useCopyToClipboard } from "react-use";
import { useWaitForTransactionReceipt, useWriteContract } from "wagmi";
import UserPageIdentityStatementsConsolidatedAddressesItemPrimary from "./UserPageIdentityStatementsConsolidatedAddressesItemPrimary";
export default function UserPageIdentityStatementsConsolidatedAddressesItem(t0) {
  const $ = _c(108);
  const {
    address,
    primaryAddress,
    canEdit,
    isOpen,
    onToggleOpen
  } = t0;
  const {
    setToast
  } = useAuth();
  let t1;
  if ($[0] !== address.display || $[1] !== address.wallet) {
    bb0: {
      const value = address.display.trim();
      if (!value) {
        t1 = null;
        break bb0;
      }
      if (value.toLowerCase() === address.wallet.toLowerCase()) {
        t1 = null;
        break bb0;
      }
      t1 = value.endsWith(".eth") ? value : null;
    }
    $[0] = address.display;
    $[1] = address.wallet;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const ensName = t1;
  let t2;
  if ($[3] !== address.wallet) {
    t2 = e => {
      e.stopPropagation();
      window.open(`https://opensea.io/${address.wallet}`, "_blank");
    };
    $[3] = address.wallet;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const goToOpensea = t2;
  let t3;
  if ($[5] !== address.wallet) {
    t3 = e_0 => {
      e_0.stopPropagation();
      window.open(`https://etherscan.io/address/${address.wallet}`, "_blank");
    };
    $[5] = address.wallet;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const goToEtherscan = t3;
  let t4;
  if ($[7] !== address.wallet) {
    t4 = address.wallet.toLowerCase();
    $[7] = address.wallet;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== primaryAddress) {
    t5 = primaryAddress?.toLowerCase();
    $[9] = primaryAddress;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const isPrimary = t4 === t5;
  const [copiedItem, setCopiedItem] = useState(null);
  const resetTimerRef = useRef(null);
  const [, copyToClipboard] = useCopyToClipboard();
  let t6;
  if ($[11] !== address.wallet || $[12] !== copyToClipboard) {
    t6 = event => {
      event.stopPropagation();
      copyToClipboard(address.wallet);
      setCopiedItem("full-address");
      if (resetTimerRef.current) {
        clearTimeout(resetTimerRef.current);
      }
      resetTimerRef.current = setTimeout(() => {
        setCopiedItem(_temp);
        resetTimerRef.current = null;
      }, 1000);
    };
    $[11] = address.wallet;
    $[12] = copyToClipboard;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const handleCopyAddress = t6;
  let t7;
  if ($[14] !== copyToClipboard || $[15] !== ensName) {
    t7 = event_0 => {
      if (!ensName) {
        return;
      }
      event_0.stopPropagation();
      copyToClipboard(ensName);
      setCopiedItem("ens");
      if (resetTimerRef.current) {
        clearTimeout(resetTimerRef.current);
      }
      resetTimerRef.current = setTimeout(() => {
        setCopiedItem(_temp2);
        resetTimerRef.current = null;
      }, 1000);
    };
    $[14] = copyToClipboard;
    $[15] = ensName;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const handleCopyEns = t7;
  let t8;
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => () => {
      if (resetTimerRef.current) {
        clearTimeout(resetTimerRef.current);
      }
    };
    t9 = [];
    $[17] = t8;
    $[18] = t9;
  } else {
    t8 = $[17];
    t9 = $[18];
  }
  useEffect(t8, t9);
  const [isTouchScreen, setIsTouchScreen] = useState(false);
  let t10;
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      setIsTouchScreen(window.matchMedia("(pointer: coarse)").matches);
    };
    t11 = [];
    $[19] = t10;
    $[20] = t11;
  } else {
    t10 = $[19];
    t11 = $[20];
  }
  useEffect(t10, t11);
  const [assigningPrimary, setAssigningPrimary] = useState(false);
  const [statusMessage, setStatusMessage] = useState();
  const writeDelegation = useWriteContract();
  let t12;
  if ($[21] !== writeDelegation.data) {
    t12 = {
      confirmations: 1,
      hash: writeDelegation.data
    };
    $[21] = writeDelegation.data;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const waitWriteDelegation = useWaitForTransactionReceipt(t12);
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = function getError(e_1) {
      return e_1.message.split("Request Arguments")[0];
    };
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const getError = t13;
  let t14;
  if ($[24] !== setToast || $[25] !== waitWriteDelegation.data || $[26] !== waitWriteDelegation.error || $[27] !== waitWriteDelegation.isLoading || $[28] !== writeDelegation.data || $[29] !== writeDelegation.isPending) {
    t14 = () => {
      if (writeDelegation.isPending) {
        setStatusMessage("Confirm in your wallet...");
      } else {
        if (writeDelegation.data) {
          const trxLink = <>{writeDelegation.data && <a href={getTransactionLink(DELEGATION_CONTRACT.chain_id, writeDelegation.data)} target="_blank" rel="noopener noreferrer" className="tw-text-primary-400 tw-underline">View Transaction</a>}</>;
          if (waitWriteDelegation.isLoading) {
            setStatusMessage(<>Waiting for confirmation... {trxLink}</>);
          } else {
            if (waitWriteDelegation.data) {
              setStatusMessage(<>Confirmed! Check back in a few minutes to see the change. {trxLink}</>);
              setToast({
                type: "success",
                message: "Primary address set successfully"
              });
            } else {
              if (waitWriteDelegation.error) {
                setStatusMessage(<>Error: {getError(waitWriteDelegation.error)} {trxLink}</>);
                setToast({
                  type: "error",
                  message: `Error setting primary address: ${getError(waitWriteDelegation.error)}`
                });
              }
            }
          }
        } else {
          setStatusMessage(undefined);
        }
      }
    };
    $[24] = setToast;
    $[25] = waitWriteDelegation.data;
    $[26] = waitWriteDelegation.error;
    $[27] = waitWriteDelegation.isLoading;
    $[28] = writeDelegation.data;
    $[29] = writeDelegation.isPending;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== waitWriteDelegation.status || $[32] !== writeDelegation.status) {
    t15 = [writeDelegation.status, waitWriteDelegation.status];
    $[31] = waitWriteDelegation.status;
    $[32] = writeDelegation.status;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  useEffect(t14, t15);
  let t16;
  if ($[34] !== address.wallet || $[35] !== writeDelegation) {
    t16 = async () => {
      setAssigningPrimary(true);
      writeDelegation.writeContract({
        address: DELEGATION_CONTRACT.contract,
        abi: DELEGATION_ABI,
        chainId: DELEGATION_CONTRACT.chain_id,
        functionName: "registerDelegationAddress",
        args: [DELEGATION_ALL_ADDRESS, address.wallet, NEVER_DATE, PRIMARY_ADDRESS_USE_CASE.use_case, true, 0]
      });
    };
    $[34] = address.wallet;
    $[35] = writeDelegation;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const assignPrimary = t16;
  const t17 = `consolidated-address-panel-${address.wallet}`;
  let t18;
  if ($[37] !== address.wallet) {
    t18 = address.wallet.slice(0, 6);
    $[37] = address.wallet;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== isOpen || $[40] !== onToggleOpen || $[41] !== t17 || $[42] !== t18) {
    t19 = <button type="button" aria-expanded={isOpen} aria-controls={t17} onClick={onToggleOpen} className="tw-border-0 tw-bg-transparent tw-p-0 tw-text-left tw-font-mono tw-text-xs tw-font-normal tw-leading-none tw-text-iron-100 hover:tw-text-white focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-emerald-400">{t18}</button>;
    $[39] = isOpen;
    $[40] = onToggleOpen;
    $[41] = t17;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== assignPrimary || $[45] !== assigningPrimary || $[46] !== canEdit || $[47] !== isPrimary) {
    t20 = <UserPageIdentityStatementsConsolidatedAddressesItemPrimary isPrimary={isPrimary} canEdit={canEdit} assignPrimary={assignPrimary} isAssigningPrimary={assigningPrimary} />;
    $[44] = assignPrimary;
    $[45] = assigningPrimary;
    $[46] = canEdit;
    $[47] = isPrimary;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t19 || $[50] !== t20) {
    t21 = <div className="tw-flex tw-items-center tw-gap-1">{t19}{t20}</div>;
    $[49] = t19;
    $[50] = t20;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== address.wallet || $[53] !== ensName || $[54] !== isOpen || $[55] !== onToggleOpen) {
    t22 = ensName && <button type="button" aria-expanded={isOpen} aria-controls={`consolidated-address-panel-${address.wallet}`} onClick={onToggleOpen} className="tw-mt-1 tw-max-w-full tw-truncate tw-border-0 tw-bg-transparent tw-p-0 tw-text-left tw-font-mono tw-text-xs tw-font-semibold tw-leading-4 tw-text-iron-100 hover:tw-text-white focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-emerald-400">{ensName}</button>;
    $[52] = address.wallet;
    $[53] = ensName;
    $[54] = isOpen;
    $[55] = onToggleOpen;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== t21 || $[58] !== t22) {
    t23 = <div className="tw-min-w-0 tw-flex-1">{t21}{t22}</div>;
    $[57] = t21;
    $[58] = t22;
    $[59] = t23;
  } else {
    t23 = $[59];
  }
  const t24 = `etherscan-tooltip-${address.wallet}`;
  const t25 = isTouchScreen ? null : "Etherscan";
  let t26;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <div className="tw-flex tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-items-center tw-justify-center"><EtherscanIcon /></div>;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  let t27;
  if ($[61] !== goToEtherscan || $[62] !== t24 || $[63] !== t25) {
    t27 = <button type="button" onClick={goToEtherscan} aria-label="Go to Etherscan" className="tw-cursor-pointer tw-border-none tw-bg-transparent tw-p-0.5 tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-200" data-tooltip-id={t24} data-tooltip-content={t25}>{t26}</button>;
    $[61] = goToEtherscan;
    $[62] = t24;
    $[63] = t25;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  let t28;
  if ($[65] !== address.wallet || $[66] !== isTouchScreen) {
    t28 = !isTouchScreen && <Tooltip id={`etherscan-tooltip-${address.wallet}`} place="top" positionStrategy="fixed" offset={8} opacity={1} style={TOOLTIP_STYLES} />;
    $[65] = address.wallet;
    $[66] = isTouchScreen;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  const t29 = `opensea-tooltip-${address.wallet}`;
  const t30 = isTouchScreen ? null : "Opensea";
  let t31;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <div className="tw-flex tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-items-center tw-justify-center"><OpenseaIcon /></div>;
    $[68] = t31;
  } else {
    t31 = $[68];
  }
  let t32;
  if ($[69] !== goToOpensea || $[70] !== t29 || $[71] !== t30) {
    t32 = <button type="button" onClick={goToOpensea} aria-label="Go to Opensea" className="tw-cursor-pointer tw-border-none tw-bg-transparent tw-p-0.5 tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-200" data-tooltip-id={t29} data-tooltip-content={t30}>{t31}</button>;
    $[69] = goToOpensea;
    $[70] = t29;
    $[71] = t30;
    $[72] = t32;
  } else {
    t32 = $[72];
  }
  let t33;
  if ($[73] !== address.wallet || $[74] !== isTouchScreen) {
    t33 = !isTouchScreen && <Tooltip id={`opensea-tooltip-${address.wallet}`} place="top" positionStrategy="fixed" offset={8} opacity={1} style={TOOLTIP_STYLES} />;
    $[73] = address.wallet;
    $[74] = isTouchScreen;
    $[75] = t33;
  } else {
    t33 = $[75];
  }
  const t34 = isOpen ? "Collapse consolidated address details" : "Expand consolidated address details";
  const t35 = `consolidated-address-panel-${address.wallet}`;
  const t36 = `tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-transition-transform tw-duration-300 tw-ease-out ${isOpen ? "tw-rotate-180" : ""}`;
  let t37;
  if ($[76] !== t36) {
    t37 = <ChevronDownIcon className={t36} aria-hidden="true" />;
    $[76] = t36;
    $[77] = t37;
  } else {
    t37 = $[77];
  }
  let t38;
  if ($[78] !== isOpen || $[79] !== onToggleOpen || $[80] !== t34 || $[81] !== t35 || $[82] !== t37) {
    t38 = <button type="button" aria-label={t34} aria-expanded={isOpen} aria-controls={t35} onClick={onToggleOpen} className="tw-border-0 tw-bg-transparent tw-p-0.5 tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-200 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-emerald-400">{t37}</button>;
    $[78] = isOpen;
    $[79] = onToggleOpen;
    $[80] = t34;
    $[81] = t35;
    $[82] = t37;
    $[83] = t38;
  } else {
    t38 = $[83];
  }
  let t39;
  if ($[84] !== t27 || $[85] !== t28 || $[86] !== t32 || $[87] !== t33 || $[88] !== t38) {
    t39 = <div className="tw-ml-auto tw-flex tw-flex-shrink-0 tw-items-center tw-gap-1.5">{t27}{t28}{t32}{t33}{t38}</div>;
    $[84] = t27;
    $[85] = t28;
    $[86] = t32;
    $[87] = t33;
    $[88] = t38;
    $[89] = t39;
  } else {
    t39 = $[89];
  }
  let t40;
  if ($[90] !== t23 || $[91] !== t39) {
    t40 = <div className="tw-flex tw-items-start tw-justify-between tw-gap-2 tw-px-3 tw-py-2">{t23}{t39}</div>;
    $[90] = t23;
    $[91] = t39;
    $[92] = t40;
  } else {
    t40 = $[92];
  }
  let t41;
  if ($[93] !== address.wallet || $[94] !== copiedItem || $[95] !== ensName || $[96] !== handleCopyAddress || $[97] !== handleCopyEns || $[98] !== isOpen) {
    t41 = isOpen && <div id={`consolidated-address-panel-${address.wallet}`} className="tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-white/10 tw-px-3 tw-pb-3 tw-pt-2"><div className="tw-space-y-2.5"><div><div className="tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">Full Address</div><div className="tw-mt-1 tw-flex tw-items-center tw-justify-between tw-gap-1.5 tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-black/40 tw-px-2.5 tw-py-1.5"><span className="tw-break-all tw-font-mono tw-text-xs tw-font-medium tw-leading-4 tw-text-iron-100">{address.wallet}</span><button type="button" aria-label="Copy full address" onClick={handleCopyAddress} className={`tw-flex tw-h-7 tw-w-7 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded tw-border-0 tw-bg-iron-900 tw-transition tw-duration-300 tw-ease-out focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-emerald-400 ${copiedItem === "full-address" ? "tw-text-primary-400" : "tw-text-iron-400 hover:tw-text-iron-200"}`}><div className="tw-flex tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-items-center tw-justify-center [&>svg]:tw-h-full [&>svg]:tw-w-full"><CopyIcon /></div></button></div></div>{ensName && <div><div className="tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">ENS Name</div><div className="tw-mt-1 tw-flex tw-items-center tw-justify-between tw-gap-1.5 tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-black/40 tw-px-2.5 tw-py-1.5"><span className="tw-break-all tw-font-mono tw-text-xs tw-font-medium tw-leading-4 tw-text-iron-100">{ensName}</span><button type="button" aria-label="Copy ens name" onClick={handleCopyEns} className={`tw-flex tw-h-7 tw-w-7 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded tw-border-0 tw-bg-iron-900 tw-transition tw-duration-300 tw-ease-out focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-emerald-400 ${copiedItem === "ens" ? "tw-text-primary-400" : "tw-text-iron-400 hover:tw-text-iron-200"}`}><div className="tw-flex tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-items-center tw-justify-center [&>svg]:tw-h-full [&>svg]:tw-w-full"><CopyIcon /></div></button></div></div>}</div></div>;
    $[93] = address.wallet;
    $[94] = copiedItem;
    $[95] = ensName;
    $[96] = handleCopyAddress;
    $[97] = handleCopyEns;
    $[98] = isOpen;
    $[99] = t41;
  } else {
    t41 = $[99];
  }
  let t42;
  if ($[100] !== t40 || $[101] !== t41) {
    t42 = <div className="tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-iron-950/40">{t40}{t41}</div>;
    $[100] = t40;
    $[101] = t41;
    $[102] = t42;
  } else {
    t42 = $[102];
  }
  let t43;
  if ($[103] !== statusMessage) {
    t43 = statusMessage && <div className="tw-pt-2 tw-text-xs tw-font-medium tw-text-iron-200">{statusMessage}</div>;
    $[103] = statusMessage;
    $[104] = t43;
  } else {
    t43 = $[104];
  }
  let t44;
  if ($[105] !== t42 || $[106] !== t43) {
    t44 = <li>{t42}{t43}</li>;
    $[105] = t42;
    $[106] = t43;
    $[107] = t44;
  } else {
    t44 = $[107];
  }
  return t44;
}
function _temp2(current_0) {
  return current_0 === "ens" ? null : current_0;
}
function _temp(current) {
  return current === "full-address" ? null : current;
}